import type { Maybe } from '@adornis/base/utilTypes.js';
import { context } from '@adornis/baseql/server/context.js';
import type { ColorDefinitions } from './entities/ColorDefinitions.js';

export type BHBaseQlContext = {
  institutionID: string;
  ignoreCapacity: boolean;
  participationStateChangeWasInitiatedByAdmin: boolean;
  colorDefinitions: Maybe<ColorDefinitions>;
};

export const bhBaseQlContext = context as unknown as BHBaseQlContext;
